<template>
    <div class="d-flex align-items-center justify-content-between w-100">
        <div class="d-flex align-items-center">
            <font-awesome-icon :icon="['far', 'map']" class="color-purple mr-2" />
            <span>{{ itemLabel }}</span>
        </div>
        <div class="d-flex justify-content-end">
            <c-button
                v-tippy
                content="Set as Default Style"
                size="icon"
                :icon="[isDefault ? 'fas' : 'far', 'star']"
                :disabled="readonly"
                @click="$emit('set-default', id)"
            />
            <c-button
                v-if="isEditable"
                size="icon"
                :icon="['far', 'pen']"
                :disabled="readonly"
                @click="$emit('edit', id)"
            />
            <c-button size="icon" :icon="['far', 'trash-can']" :disabled="readonly" @click="$emit('remove', item)" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import CButton from '@/components/shared/CButton';
import { MAP_STYLE_PRESETS } from '@/components/DesignStudio/MapStyleProperties/presets';

interface Props {
    id: number;
    item: string;
    readonly?: boolean;
    isDefault: boolean;
}

interface Emits {
    (event: 'edit', id: number): void;
    (event: 'remove', value: string): void;
    (event: 'set-default', value: number): void;
}

const props = defineProps<Props>();
defineEmits<Emits>();

const mapStyle = computed(() => MAP_STYLE_PRESETS.find((preset) => preset.id === props.item));
const isEditable = computed(() => !MAP_STYLE_PRESETS.some((preset) => preset.id === props.item));
const itemLabel = computed(() => (mapStyle.value ? mapStyle.value.label : `Custom Style - ${props.item}`));
</script>
